<template>
  <v-container>
    <h1>Konfigurasjon av betalingsmetoder</h1>
    <AdminBreadcrumbs tail-text="Betalingsmetoder" />

    <v-card class="orange lighten-5" elevation="3">
      <v-card-title class="white--text orange">
        Vipps konfigurasjon
        <v-spacer />
        <v-img
          :src="require('@/assets/vipps-white.png')"
          max-width="100"
          max-height="50"
        />
      </v-card-title>
      <VippsConfiguration :organization-id="organizationId" />
    </v-card>

    <v-card class="orange lighten-5 mt-5" elevation="3">
      <v-card-title class="white--text orange">
        Stripe konfigurasjon
        <v-spacer />
        <v-img
          :src="require('@/assets/stripe-white.png')"
          max-width="100"
          max-height="50"
        />
      </v-card-title>
      <StripeConfiguration :organization-id="organizationId" />
    </v-card>

    <v-card class="orange lighten-5 mt-5" elevation="3">
      <v-card-title class="white--text orange"
        >Offline konfigurasjon</v-card-title
      >
      <OfflineConfiguration :organization-id="organizationId" />
    </v-card>
  </v-container>
</template>

<script>
import StripeConfiguration from "@/components/StripeConfiguration.vue";
import OfflineConfiguration from "@/components/OfflineConfiguration.vue";
import VippsConfiguration from "@/components/VippsConfiguration.vue";
import AdminBreadcrumbs from "@/components/AdminBreadcrumbs.vue";

export default {
  name: "AdminPaymentConfiguration",

  components: {
    StripeConfiguration,
    VippsConfiguration,
    OfflineConfiguration,
    AdminBreadcrumbs,
  },

  computed: {
    organizationId() {
      return this.$store.state.auth.organization.id;
    },
  },
};
</script>
